/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ChangeExamDayStatusRequestDto } from '../models';
// @ts-ignore
import type { CommissionMembersResponseDto } from '../models';
// @ts-ignore
import type { CreateExamDayRequestDto } from '../models';
// @ts-ignore
import type { ExamDayDetailDto } from '../models';
// @ts-ignore
import type { ExamDayStatusDto } from '../models';
// @ts-ignore
import type { ExamDaysResponseDto } from '../models';
// @ts-ignore
import type { GenerateExamsResultDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { UpdateExamDayDetailsRequestDto } from '../models';
// @ts-ignore
import type { UpdateExamDayLocationRequestDto } from '../models';
/**
 * ExamDayApi - axios parameter creator
 * @export
 */
export const ExamDayApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Allowed transitions: DRAFT -> IN_PROGRESS, IN_PROGRESS -> COMPLETED, DRAFT|IN_PROGRESS -> CANCELLED. 
         * @summary Change exam day status
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {ChangeExamDayStatusRequestDto} changeExamDayStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeExamDayStatus: async (certificationId: number, stageId: number, examDayId: string, changeExamDayStatusRequestDto: ChangeExamDayStatusRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('changeExamDayStatus', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('changeExamDayStatus', 'stageId', stageId)
            // verify required parameter 'examDayId' is not null or undefined
            assertParamExists('changeExamDayStatus', 'examDayId', examDayId)
            // verify required parameter 'changeExamDayStatusRequestDto' is not null or undefined
            assertParamExists('changeExamDayStatus', 'changeExamDayStatusRequestDto', changeExamDayStatusRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/days/{examDayId}/status`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examDayId"}}`, encodeURIComponent(String(examDayId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeExamDayStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create exam day
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {CreateExamDayRequestDto} createExamDayRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExamDay: async (certificationId: number, stageId: number, createExamDayRequestDto: CreateExamDayRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('createExamDay', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('createExamDay', 'stageId', stageId)
            // verify required parameter 'createExamDayRequestDto' is not null or undefined
            assertParamExists('createExamDay', 'createExamDayRequestDto', createExamDayRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/days`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createExamDayRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates individual exams for all exam day participants who don\'t have one yet. Randomly selects questions from the question pool. 
         * @summary Generate individual exams for exam day
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateExams: async (certificationId: number, stageId: number, examDayId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('generateExams', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('generateExams', 'stageId', stageId)
            // verify required parameter 'examDayId' is not null or undefined
            assertParamExists('generateExams', 'examDayId', examDayId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/days/{examDayId}/generate-exams`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examDayId"}}`, encodeURIComponent(String(examDayId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns unique list of all commission members (chairman + HRBP) across all exam days. Used for filtering. 
         * @summary List commission members
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExamCommissionMembers: async (certificationId: number, stageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getExamCommissionMembers', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getExamCommissionMembers', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/days/commission-members`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns exam day details with participant list and their exam status. 
         * @summary Get exam day detail
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExamDayDetail: async (certificationId: number, stageId: number, examDayId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getExamDayDetail', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getExamDayDetail', 'stageId', stageId)
            // verify required parameter 'examDayId' is not null or undefined
            assertParamExists('getExamDayDetail', 'examDayId', examDayId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/days/{examDayId}`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examDayId"}}`, encodeURIComponent(String(examDayId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated list of exam days with filters. 
         * @summary List exam days
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Fulltext search po nazwie/kodzie sklepu (location), imieniu/nazwisku przewodniczącego oraz HRBP
         * @param {ExamDayStatusDto} [status] 
         * @param {string} [dateFrom] Filter from date (inclusive, YYYY-MM-DD)
         * @param {string} [dateTo] Filter to date (inclusive, YYYY-MM-DD)
         * @param {Array<string>} [commissionMemberIds] Filter by commission member employee IDs (CSV). Matches chairman OR HRBP.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExamDays: async (certificationId: number, stageId: number, page?: number, pageSize?: number, search?: string, status?: ExamDayStatusDto, dateFrom?: string, dateTo?: string, commissionMemberIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getExamDays', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getExamDays', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/days`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substring(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substring(0,10) :
                    dateTo;
            }

            if (commissionMemberIds) {
                localVarQueryParameter['commissionMemberIds'] = commissionMemberIds.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zmienia datę i komisję (przewodniczący + HRBP) dnia egzaminu. Dozwolone wyłącznie gdy dzień jest w statusie DRAFT, jego bieżąca data jest dzisiejsza lub przyszła, a nowa data również jest dzisiejsza lub przyszła. 
         * @summary Update exam day date and commission
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {UpdateExamDayDetailsRequestDto} updateExamDayDetailsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExamDayDetails: async (certificationId: number, stageId: number, examDayId: string, updateExamDayDetailsRequestDto: UpdateExamDayDetailsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('updateExamDayDetails', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('updateExamDayDetails', 'stageId', stageId)
            // verify required parameter 'examDayId' is not null or undefined
            assertParamExists('updateExamDayDetails', 'examDayId', examDayId)
            // verify required parameter 'updateExamDayDetailsRequestDto' is not null or undefined
            assertParamExists('updateExamDayDetails', 'updateExamDayDetailsRequestDto', updateExamDayDetailsRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/days/{examDayId}/details`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examDayId"}}`, encodeURIComponent(String(examDayId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateExamDayDetailsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zmienia sklep (miejsce) dnia egzaminu. Dozwolone niezależnie od statusu dnia (DRAFT, IN_PROGRESS, COMPLETED, CANCELLED). 
         * @summary Change exam day location
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {UpdateExamDayLocationRequestDto} updateExamDayLocationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExamDayLocation: async (certificationId: number, stageId: number, examDayId: string, updateExamDayLocationRequestDto: UpdateExamDayLocationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('updateExamDayLocation', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('updateExamDayLocation', 'stageId', stageId)
            // verify required parameter 'examDayId' is not null or undefined
            assertParamExists('updateExamDayLocation', 'examDayId', examDayId)
            // verify required parameter 'updateExamDayLocationRequestDto' is not null or undefined
            assertParamExists('updateExamDayLocation', 'updateExamDayLocationRequestDto', updateExamDayLocationRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/days/{examDayId}/location`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examDayId"}}`, encodeURIComponent(String(examDayId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateExamDayLocationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExamDayApi - functional programming interface
 * @export
 */
export const ExamDayApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExamDayApiAxiosParamCreator(configuration)
    return {
        /**
         * Allowed transitions: DRAFT -> IN_PROGRESS, IN_PROGRESS -> COMPLETED, DRAFT|IN_PROGRESS -> CANCELLED. 
         * @summary Change exam day status
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {ChangeExamDayStatusRequestDto} changeExamDayStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeExamDayStatus(certificationId: number, stageId: number, examDayId: string, changeExamDayStatusRequestDto: ChangeExamDayStatusRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamDayDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeExamDayStatus(certificationId, stageId, examDayId, changeExamDayStatusRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamDayApi.changeExamDayStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create exam day
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {CreateExamDayRequestDto} createExamDayRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExamDay(certificationId: number, stageId: number, createExamDayRequestDto: CreateExamDayRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamDayDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExamDay(certificationId, stageId, createExamDayRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamDayApi.createExamDay']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates individual exams for all exam day participants who don\'t have one yet. Randomly selects questions from the question pool. 
         * @summary Generate individual exams for exam day
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateExams(certificationId: number, stageId: number, examDayId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateExamsResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateExams(certificationId, stageId, examDayId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamDayApi.generateExams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns unique list of all commission members (chairman + HRBP) across all exam days. Used for filtering. 
         * @summary List commission members
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExamCommissionMembers(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommissionMembersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExamCommissionMembers(certificationId, stageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamDayApi.getExamCommissionMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns exam day details with participant list and their exam status. 
         * @summary Get exam day detail
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExamDayDetail(certificationId: number, stageId: number, examDayId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamDayDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExamDayDetail(certificationId, stageId, examDayId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamDayApi.getExamDayDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated list of exam days with filters. 
         * @summary List exam days
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Fulltext search po nazwie/kodzie sklepu (location), imieniu/nazwisku przewodniczącego oraz HRBP
         * @param {ExamDayStatusDto} [status] 
         * @param {string} [dateFrom] Filter from date (inclusive, YYYY-MM-DD)
         * @param {string} [dateTo] Filter to date (inclusive, YYYY-MM-DD)
         * @param {Array<string>} [commissionMemberIds] Filter by commission member employee IDs (CSV). Matches chairman OR HRBP.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExamDays(certificationId: number, stageId: number, page?: number, pageSize?: number, search?: string, status?: ExamDayStatusDto, dateFrom?: string, dateTo?: string, commissionMemberIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamDaysResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExamDays(certificationId, stageId, page, pageSize, search, status, dateFrom, dateTo, commissionMemberIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamDayApi.getExamDays']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zmienia datę i komisję (przewodniczący + HRBP) dnia egzaminu. Dozwolone wyłącznie gdy dzień jest w statusie DRAFT, jego bieżąca data jest dzisiejsza lub przyszła, a nowa data również jest dzisiejsza lub przyszła. 
         * @summary Update exam day date and commission
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {UpdateExamDayDetailsRequestDto} updateExamDayDetailsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExamDayDetails(certificationId: number, stageId: number, examDayId: string, updateExamDayDetailsRequestDto: UpdateExamDayDetailsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamDayDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExamDayDetails(certificationId, stageId, examDayId, updateExamDayDetailsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamDayApi.updateExamDayDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zmienia sklep (miejsce) dnia egzaminu. Dozwolone niezależnie od statusu dnia (DRAFT, IN_PROGRESS, COMPLETED, CANCELLED). 
         * @summary Change exam day location
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {UpdateExamDayLocationRequestDto} updateExamDayLocationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExamDayLocation(certificationId: number, stageId: number, examDayId: string, updateExamDayLocationRequestDto: UpdateExamDayLocationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamDayDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExamDayLocation(certificationId, stageId, examDayId, updateExamDayLocationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExamDayApi.updateExamDayLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExamDayApi - factory interface
 * @export
 */
export const ExamDayApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExamDayApiFp(configuration)
    return {
        /**
         * Allowed transitions: DRAFT -> IN_PROGRESS, IN_PROGRESS -> COMPLETED, DRAFT|IN_PROGRESS -> CANCELLED. 
         * @summary Change exam day status
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {ChangeExamDayStatusRequestDto} changeExamDayStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeExamDayStatus(certificationId: number, stageId: number, examDayId: string, changeExamDayStatusRequestDto: ChangeExamDayStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExamDayDetailDto> {
            return localVarFp.changeExamDayStatus(certificationId, stageId, examDayId, changeExamDayStatusRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create exam day
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {CreateExamDayRequestDto} createExamDayRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExamDay(certificationId: number, stageId: number, createExamDayRequestDto: CreateExamDayRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExamDayDetailDto> {
            return localVarFp.createExamDay(certificationId, stageId, createExamDayRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates individual exams for all exam day participants who don\'t have one yet. Randomly selects questions from the question pool. 
         * @summary Generate individual exams for exam day
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateExams(certificationId: number, stageId: number, examDayId: string, options?: RawAxiosRequestConfig): AxiosPromise<GenerateExamsResultDto> {
            return localVarFp.generateExams(certificationId, stageId, examDayId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns unique list of all commission members (chairman + HRBP) across all exam days. Used for filtering. 
         * @summary List commission members
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExamCommissionMembers(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<CommissionMembersResponseDto> {
            return localVarFp.getExamCommissionMembers(certificationId, stageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns exam day details with participant list and their exam status. 
         * @summary Get exam day detail
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExamDayDetail(certificationId: number, stageId: number, examDayId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExamDayDetailDto> {
            return localVarFp.getExamDayDetail(certificationId, stageId, examDayId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated list of exam days with filters. 
         * @summary List exam days
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Fulltext search po nazwie/kodzie sklepu (location), imieniu/nazwisku przewodniczącego oraz HRBP
         * @param {ExamDayStatusDto} [status] 
         * @param {string} [dateFrom] Filter from date (inclusive, YYYY-MM-DD)
         * @param {string} [dateTo] Filter to date (inclusive, YYYY-MM-DD)
         * @param {Array<string>} [commissionMemberIds] Filter by commission member employee IDs (CSV). Matches chairman OR HRBP.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExamDays(certificationId: number, stageId: number, page?: number, pageSize?: number, search?: string, status?: ExamDayStatusDto, dateFrom?: string, dateTo?: string, commissionMemberIds?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<ExamDaysResponseDto> {
            return localVarFp.getExamDays(certificationId, stageId, page, pageSize, search, status, dateFrom, dateTo, commissionMemberIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Zmienia datę i komisję (przewodniczący + HRBP) dnia egzaminu. Dozwolone wyłącznie gdy dzień jest w statusie DRAFT, jego bieżąca data jest dzisiejsza lub przyszła, a nowa data również jest dzisiejsza lub przyszła. 
         * @summary Update exam day date and commission
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {UpdateExamDayDetailsRequestDto} updateExamDayDetailsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExamDayDetails(certificationId: number, stageId: number, examDayId: string, updateExamDayDetailsRequestDto: UpdateExamDayDetailsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExamDayDetailDto> {
            return localVarFp.updateExamDayDetails(certificationId, stageId, examDayId, updateExamDayDetailsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Zmienia sklep (miejsce) dnia egzaminu. Dozwolone niezależnie od statusu dnia (DRAFT, IN_PROGRESS, COMPLETED, CANCELLED). 
         * @summary Change exam day location
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examDayId 
         * @param {UpdateExamDayLocationRequestDto} updateExamDayLocationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExamDayLocation(certificationId: number, stageId: number, examDayId: string, updateExamDayLocationRequestDto: UpdateExamDayLocationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExamDayDetailDto> {
            return localVarFp.updateExamDayLocation(certificationId, stageId, examDayId, updateExamDayLocationRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExamDayApi - interface
 * @export
 * @interface ExamDayApi
 */
export interface ExamDayApiInterface {
    /**
     * Allowed transitions: DRAFT -> IN_PROGRESS, IN_PROGRESS -> COMPLETED, DRAFT|IN_PROGRESS -> CANCELLED. 
     * @summary Change exam day status
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examDayId 
     * @param {ChangeExamDayStatusRequestDto} changeExamDayStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayApiInterface
     */
    changeExamDayStatus(certificationId: number, stageId: number, examDayId: string, changeExamDayStatusRequestDto: ChangeExamDayStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExamDayDetailDto>;

    /**
     * 
     * @summary Create exam day
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {CreateExamDayRequestDto} createExamDayRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayApiInterface
     */
    createExamDay(certificationId: number, stageId: number, createExamDayRequestDto: CreateExamDayRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExamDayDetailDto>;

    /**
     * Generates individual exams for all exam day participants who don\'t have one yet. Randomly selects questions from the question pool. 
     * @summary Generate individual exams for exam day
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examDayId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayApiInterface
     */
    generateExams(certificationId: number, stageId: number, examDayId: string, options?: RawAxiosRequestConfig): AxiosPromise<GenerateExamsResultDto>;

    /**
     * Returns unique list of all commission members (chairman + HRBP) across all exam days. Used for filtering. 
     * @summary List commission members
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayApiInterface
     */
    getExamCommissionMembers(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<CommissionMembersResponseDto>;

    /**
     * Returns exam day details with participant list and their exam status. 
     * @summary Get exam day detail
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examDayId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayApiInterface
     */
    getExamDayDetail(certificationId: number, stageId: number, examDayId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExamDayDetailDto>;

    /**
     * Returns paginated list of exam days with filters. 
     * @summary List exam days
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Fulltext search po nazwie/kodzie sklepu (location), imieniu/nazwisku przewodniczącego oraz HRBP
     * @param {ExamDayStatusDto} [status] 
     * @param {string} [dateFrom] Filter from date (inclusive, YYYY-MM-DD)
     * @param {string} [dateTo] Filter to date (inclusive, YYYY-MM-DD)
     * @param {Array<string>} [commissionMemberIds] Filter by commission member employee IDs (CSV). Matches chairman OR HRBP.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayApiInterface
     */
    getExamDays(certificationId: number, stageId: number, page?: number, pageSize?: number, search?: string, status?: ExamDayStatusDto, dateFrom?: string, dateTo?: string, commissionMemberIds?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<ExamDaysResponseDto>;

    /**
     * Zmienia datę i komisję (przewodniczący + HRBP) dnia egzaminu. Dozwolone wyłącznie gdy dzień jest w statusie DRAFT, jego bieżąca data jest dzisiejsza lub przyszła, a nowa data również jest dzisiejsza lub przyszła. 
     * @summary Update exam day date and commission
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examDayId 
     * @param {UpdateExamDayDetailsRequestDto} updateExamDayDetailsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayApiInterface
     */
    updateExamDayDetails(certificationId: number, stageId: number, examDayId: string, updateExamDayDetailsRequestDto: UpdateExamDayDetailsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExamDayDetailDto>;

    /**
     * Zmienia sklep (miejsce) dnia egzaminu. Dozwolone niezależnie od statusu dnia (DRAFT, IN_PROGRESS, COMPLETED, CANCELLED). 
     * @summary Change exam day location
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examDayId 
     * @param {UpdateExamDayLocationRequestDto} updateExamDayLocationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayApiInterface
     */
    updateExamDayLocation(certificationId: number, stageId: number, examDayId: string, updateExamDayLocationRequestDto: UpdateExamDayLocationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExamDayDetailDto>;

}

/**
 * ExamDayApi - object-oriented interface
 * @export
 * @class ExamDayApi
 * @extends {BaseAPI}
 */
export class ExamDayApi extends BaseAPI implements ExamDayApiInterface {
    /**
     * Allowed transitions: DRAFT -> IN_PROGRESS, IN_PROGRESS -> COMPLETED, DRAFT|IN_PROGRESS -> CANCELLED. 
     * @summary Change exam day status
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examDayId 
     * @param {ChangeExamDayStatusRequestDto} changeExamDayStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayApi
     */
    public changeExamDayStatus(certificationId: number, stageId: number, examDayId: string, changeExamDayStatusRequestDto: ChangeExamDayStatusRequestDto, options?: RawAxiosRequestConfig) {
        return ExamDayApiFp(this.configuration).changeExamDayStatus(certificationId, stageId, examDayId, changeExamDayStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create exam day
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {CreateExamDayRequestDto} createExamDayRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayApi
     */
    public createExamDay(certificationId: number, stageId: number, createExamDayRequestDto: CreateExamDayRequestDto, options?: RawAxiosRequestConfig) {
        return ExamDayApiFp(this.configuration).createExamDay(certificationId, stageId, createExamDayRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates individual exams for all exam day participants who don\'t have one yet. Randomly selects questions from the question pool. 
     * @summary Generate individual exams for exam day
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examDayId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayApi
     */
    public generateExams(certificationId: number, stageId: number, examDayId: string, options?: RawAxiosRequestConfig) {
        return ExamDayApiFp(this.configuration).generateExams(certificationId, stageId, examDayId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns unique list of all commission members (chairman + HRBP) across all exam days. Used for filtering. 
     * @summary List commission members
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayApi
     */
    public getExamCommissionMembers(certificationId: number, stageId: number, options?: RawAxiosRequestConfig) {
        return ExamDayApiFp(this.configuration).getExamCommissionMembers(certificationId, stageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns exam day details with participant list and their exam status. 
     * @summary Get exam day detail
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examDayId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayApi
     */
    public getExamDayDetail(certificationId: number, stageId: number, examDayId: string, options?: RawAxiosRequestConfig) {
        return ExamDayApiFp(this.configuration).getExamDayDetail(certificationId, stageId, examDayId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated list of exam days with filters. 
     * @summary List exam days
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Fulltext search po nazwie/kodzie sklepu (location), imieniu/nazwisku przewodniczącego oraz HRBP
     * @param {ExamDayStatusDto} [status] 
     * @param {string} [dateFrom] Filter from date (inclusive, YYYY-MM-DD)
     * @param {string} [dateTo] Filter to date (inclusive, YYYY-MM-DD)
     * @param {Array<string>} [commissionMemberIds] Filter by commission member employee IDs (CSV). Matches chairman OR HRBP.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayApi
     */
    public getExamDays(certificationId: number, stageId: number, page?: number, pageSize?: number, search?: string, status?: ExamDayStatusDto, dateFrom?: string, dateTo?: string, commissionMemberIds?: Array<string>, options?: RawAxiosRequestConfig) {
        return ExamDayApiFp(this.configuration).getExamDays(certificationId, stageId, page, pageSize, search, status, dateFrom, dateTo, commissionMemberIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zmienia datę i komisję (przewodniczący + HRBP) dnia egzaminu. Dozwolone wyłącznie gdy dzień jest w statusie DRAFT, jego bieżąca data jest dzisiejsza lub przyszła, a nowa data również jest dzisiejsza lub przyszła. 
     * @summary Update exam day date and commission
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examDayId 
     * @param {UpdateExamDayDetailsRequestDto} updateExamDayDetailsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayApi
     */
    public updateExamDayDetails(certificationId: number, stageId: number, examDayId: string, updateExamDayDetailsRequestDto: UpdateExamDayDetailsRequestDto, options?: RawAxiosRequestConfig) {
        return ExamDayApiFp(this.configuration).updateExamDayDetails(certificationId, stageId, examDayId, updateExamDayDetailsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zmienia sklep (miejsce) dnia egzaminu. Dozwolone niezależnie od statusu dnia (DRAFT, IN_PROGRESS, COMPLETED, CANCELLED). 
     * @summary Change exam day location
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examDayId 
     * @param {UpdateExamDayLocationRequestDto} updateExamDayLocationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExamDayApi
     */
    public updateExamDayLocation(certificationId: number, stageId: number, examDayId: string, updateExamDayLocationRequestDto: UpdateExamDayLocationRequestDto, options?: RawAxiosRequestConfig) {
        return ExamDayApiFp(this.configuration).updateExamDayLocation(certificationId, stageId, examDayId, updateExamDayLocationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

